import { NgModule } from "@angular/core";
import { ClickOutSideDirective } from "src/app/directives/click-out-side.directive";
import { onlyNumbersDirective } from "src/app/directives/only-numberes.directive";
import { OnlyTextDirective } from "src/app/directives/only-text.directive";
import { RestrictSpecialCharsDirective } from "src/app/directives/restrict-special-chars.directive";
import { TooltipDirective } from "src/app/directives/tooltip.directive";
import { ClientSideOnlyDirective } from "src/app/directives/client-side-only.directive";
import { UniversalLazyImageDirective } from "src/app/directives/universal-lazy-image.directive";

@NgModule({
  declarations: [
    onlyNumbersDirective,
    OnlyTextDirective,
    ClickOutSideDirective,
    TooltipDirective,
    RestrictSpecialCharsDirective,
    ClientSideOnlyDirective,
    UniversalLazyImageDirective,
  ],
  imports: [],
  exports: [
    onlyNumbersDirective,
    OnlyTextDirective,
    ClickOutSideDirective,
    TooltipDirective,
    RestrictSpecialCharsDirective,
    ClientSideOnlyDirective,
    UniversalLazyImageDirective
  ],
})
export class DirectivesModule {}
